import MyParadiseDataModal from "@app/modals/MyParadise/MyParadiseDataModal/MyParadiseDataModal"
import { useGetSalutations } from "@app/store/service/connectorService"
import { useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import "./MyParadiseMyData.css"

export const MyParadiseMyData = () => {
	const relation = useSelector(state => state.core.relation)
	const { showModal } = useModal()
	let gender = ""
	const { data: salutations } = useGetSalutations()
	relation &&
		salutations &&
		salutations.forEach(e => {
			if (e.genderId === relation.genderId) gender = e.salutation
		})
	return (
		relation && (
			<div className="myParadiseMyData w-auto h-100 color-bg-secondary-100 clickable" onClick={() => showModal(MyParadiseDataModal)}>
				<div className="w-100 p-4 flex">
					<h3 className="color-fg-secondary pt-3 flex-1 regular mr-4">Adresse</h3>
					<div className="flex flex-column  flex-auto">
						<div className="mb-1 f3 regular">{gender}</div>
						<div className="mb-1 f3 regular">
							{relation.firstName} {relation.lastName}
						</div>
						<div className="mb-1 f4">
							{relation.address} {relation.houseNo}
						</div>
						<div className="f4">
							{relation.zipCode} {relation.city} {`(${(relation.countryCode || "").toUpperCase()})`}
						</div>
					</div>
				</div>
			</div>
		)
	)
}
